export const LOG_INVENTORY_REQUEST = "LOG_INVENTORY_REQUEST";
export const LOG_INVENTORY_SUCCESS = "LOG_INVENTORY_SUCCESS";
export const LOG_INVENTORY_FAILED = "LOG_INVENTORY_FAILED";
export const LOG_HISTORY_INVENTORY_REQUEST = "LOG_HISTORY_INVENTORY_REQUEST";
export const LOG_HISTORY_INVENTORY_SUCCESS = "LOG_HISTORY_INVENTORY_SUCCESS";
export const LOG_HISTORY_INVENTORY_FAILED = "LOG_HISTORY_INVENTORY_FAILED";
